var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcode2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "barcode2",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2042_26675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3527 0.361328H3.6486C1.76555 0.361328 0.5 1.68485 0.5 3.65387V8.34666C0.5 10.3157 1.7662 11.6392 3.64925 11.6392H10.3527C12.2351 11.6392 13.5 10.3157 13.5 8.34666V3.65387C13.5 1.68485 12.2351 0.361328 10.3527 0.361328Z",
    fill: "url(#paint0_linear_2042_26675)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2042_26675)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2042_26675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1.33325,
    width: 16,
    height: 16,
    fill: "url(#paint1_linear_2042_26675)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2042_26675",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14766 9.06623C8.41676 9.06623 8.63516 8.84781 8.63516 8.57869V3.41723C8.63516 3.14811 8.41676 2.92969 8.14766 2.92969C7.87856 2.92969 7.66016 3.14811 7.66016 3.41723V8.57869C7.66016 8.84781 7.87856 9.06623 8.14766 9.06623ZM10.8695 5.88208C10.8695 6.15121 10.6511 6.36963 10.382 6.36963C10.1129 6.36963 9.89453 6.15121 9.89453 5.88208V3.41772C9.89453 3.1486 10.1129 2.93018 10.382 2.93018C10.6511 2.93018 10.8695 3.1486 10.8695 3.41772V5.88208ZM10.8695 8.517C10.8695 8.78612 10.6511 9.00454 10.382 9.00454C10.1129 9.00454 9.89453 8.78612 9.89453 8.517V7.86694C9.89453 7.59781 10.1129 7.3794 10.382 7.3794C10.6511 7.3794 10.8695 7.59781 10.8695 7.86694V8.517ZM6.35001 4.06778C6.35001 4.3369 6.13161 4.55532 5.86251 4.55532C5.5934 4.55532 5.375 4.3369 5.375 4.06778V3.41772C5.375 3.1486 5.5934 2.93018 5.86251 2.93018C6.13161 2.93018 6.35001 3.1486 6.35001 3.41772V4.06778ZM5.86251 9.00391C6.13161 9.00391 6.35001 8.78549 6.35001 8.51637V6.052C6.35001 5.78287 6.13161 5.56445 5.86251 5.56445C5.5934 5.56445 5.375 5.78287 5.375 6.052V8.51637C5.375 8.78549 5.5934 9.00391 5.86251 9.00391ZM4.06484 8.57917C4.06484 8.8483 3.84644 9.06672 3.57734 9.06672C3.30824 9.06672 3.08984 8.8483 3.08984 8.57917V3.41772C3.08984 3.1486 3.30824 2.93018 3.57734 2.93018C3.84644 2.93018 4.06484 3.1486 4.06484 3.41772V8.57917Z",
    fill: "url(#paint2_linear_2042_26675)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2042_26675)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(1)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2042_26675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 12,
    height: 12,
    fill: "url(#paint3_linear_2042_26675)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2042_26675",
    x1: 0.5,
    y1: 0.361328,
    x2: 0.5,
    y2: 11.6392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2042_26675",
    x1: -1,
    y1: -1.33325,
    x2: -1,
    y2: 14.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2042_26675",
    x1: 3.08984,
    y1: 2.92969,
    x2: 3.08984,
    y2: 9.06672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2042_26675",
    x1: 1,
    y1: 0,
    x2: 1,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2042_26675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(-1 -1.33325)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2042_26675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode2);
export default __webpack_public_path__ + "static/media/barcode2.8bd48f4a.svg";
export { ForwardRef as ReactComponent };